import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import * as tracking from 'dibs-tracking';

import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import { Link } from 'dibs-elements/exports/Link';
import singleItemHoldRequestLauncher from 'dibs-buyer-layout/exports/singleItemHoldRequestLauncher';
import styles from './PdpSharedButtons.scss';

const copyHoldRequested = (
    <FormattedMessage id="PdpSharedRequestHold.holdRequested" defaultMessage="Hold requested" />
);
const copyRequestHold = (
    <FormattedMessage id="PdpSharedRequestHold.requestHold" defaultMessage="Request a Hold" />
);

export class PdpSharedRequestHoldComponent extends Component {
    constructor() {
        super();
        this.requestHold = this.requestHold.bind(this);
    }
    componentDidMount() {
        const { hasRequestedHoldForBuyer, displayInfo } = this.props.item || {};
        const queryParams = new URLSearchParams(global?.location?.search);
        const modalParam = queryParams.get('modal');

        if (
            modalParam === 'hold' &&
            !hasRequestedHoldForBuyer &&
            displayInfo?.ctas?.showHoldRequest
        ) {
            this.requestHold();
        }
    }
    requestHold(event) {
        const {
            relay: { environment },
            itemId,
            userId,
            trackingLocation,
        } = this.props;
        tracking.trackEvent(
            {
                action: 'contact dealer clicked',
                category: 'contact dealer',
                label: `request a hold - ${trackingLocation}`,
                eventName: 'contact',
                step_interaction_name: 'entry',
                interaction_type: 'contact dealer',
            },
            event
        );
        singleItemHoldRequestLauncher({
            environment,
            itemId,
            userId,
            linkLocation: trackingLocation,
        });
    }
    render() {
        const { hasRequestedHoldForBuyer, displayInfo, isAuctionEnabled } = this.props.item || {};
        const { type } = this.props;

        if (hasRequestedHoldForBuyer && !isAuctionEnabled) {
            if (type === 'button') {
                return (
                    <Button
                        type="secondary"
                        dataTn="pdp-shared-hold-requested"
                        size="small"
                        className={styles.holdRequestedButton}
                        disabled
                    >
                        {copyHoldRequested}
                    </Button>
                );
            }

            return (
                <div data-tn="pdp-shared-hold-requested" className={styles.holdLink}>
                    {copyHoldRequested}
                </div>
            );
        }

        if (displayInfo?.ctas?.showHoldRequest) {
            if (type === 'button') {
                return (
                    <Button
                        type="textCta"
                        dataTn="pdp-shared-request-hold"
                        size="medium"
                        disabled={hasRequestedHoldForBuyer}
                        onClick={this.requestHold}
                        className={styles.requestHoldButton}
                    >
                        {copyRequestHold}
                    </Button>
                );
            }

            return (
                <Link
                    dataTn="pdp-shared-request-hold"
                    onClick={this.requestHold}
                    className={styles.holdLink}
                >
                    {copyRequestHold}
                </Link>
            );
        }

        return null;
    }
}

PdpSharedRequestHoldComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object,
    user: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    trackingLocation: PropTypes.string,
    type: PropTypes.oneOf(['button', 'link']),
};

PdpSharedRequestHoldComponent.defaultProps = {
    type: 'button',
};

export const PdpSharedRequestHold = createFragmentContainer(PdpSharedRequestHoldComponent, {
    item: graphql`
        fragment PdpSharedRequestHold_item on Item {
            isAuctionEnabled
            hasRequestedHoldForBuyer(buyerId: $userId) @include(if: $isClient)
            displayInfo(page: pdp, buyerId: $userId) @include(if: $isClient) {
                ctas {
                    showHoldRequest
                }
            }
        }
    `,
});
